module.exports = __webpack_public_path__ + "img/8dbd98b.jpg";